
import { ReactNode } from "react";

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  height?: string;
  backgroundImage?: string;
  darkOverlay?: boolean;
}

const HeroSection = ({
  title,
  subtitle,
  children,
  height = "h-[400px]",
  backgroundImage = "",
  darkOverlay = true
}: HeroSectionProps) => {
  return (
    <div className="relative">
      {/* Hero background */}
      <div 
        className={`bg-fabre-gray ${height} flex items-center`}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-3xl text-white flex items-center gap-4">
            <img 
              src="/lovable-uploads/2e9c2ce6-c821-428b-baa4-bd3137a03d49.png" 
              alt="Groupe Fabre" 
              className="w-12 h-12"
            />
            <div>
              <h1 className="text-4xl md:text-5xl font-heading font-bold mb-2">
                {title}
              </h1>
              {subtitle && <p className="text-xl">{subtitle}</p>}
              {children}
            </div>
          </div>
        </div>
      </div>

      {/* Vague décorative */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-[50px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path fill="#ffffff" fillOpacity="1" d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;
